import { render, staticRenderFns } from "./AddTargetData.vue?vue&type=template&id=19d74596"
import script from "./AddTargetData.vue?vue&type=script&lang=js"
export * from "./AddTargetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports